"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryQueryLink = retryQueryLink;
const client_1 = require("@trpc/client");
/**
 * Creates a link that retries queries failded due to server or network errors.
 *
 * Adopts the offical retryLink https://trpc.io/docs/client/links/retryLink
 * @param userOptions Configuration options
 * @returns tRPC link that retries failed queries
 */
function retryQueryLink(userOptions) {
    return (0, client_1.retryLink)({
        retry(opts) {
            if (opts.error.data && opts.error.data.code !== "INTERNAL_SERVER_ERROR") {
                // Don't retry on non-500s
                return false;
            }
            if (opts.op.type !== "query") {
                // Only retry queries
                return false;
            }
            // Retry up to 3 times
            return opts.attempts <= userOptions.attempts;
        },
        // Double every attempt, with max of 30 seconds (starting at 1 second)
        retryDelayMs: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    });
}
//# sourceMappingURL=retry-query.link.js.map